import { render, staticRenderFns } from "./SysNcTemplateManagerDefault.vue?vue&type=template&id=68f2573b&scoped=true&"
import script from "./SysNcTemplateManagerDefault.vue?vue&type=script&lang=js&"
export * from "./SysNcTemplateManagerDefault.vue?vue&type=script&lang=js&"
import style0 from "./SysNcTemplateManagerDefault.vue?vue&type=style&index=0&id=68f2573b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f2573b",
  null
  
)

export default component.exports